export default __webpack_public_path__ + "static/media/resources.dc846b9f.svg";